import { Transform, Type } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';
import { PagingSearchFieldArgument } from 'src/lib/utilities/api/patterns/pagination/paging-search-field.argument';

export class GradPlanAssociationsModel {
	student_count: number;
	program_count: number;
	required_subject_area_credits: number;
	required_course_credits: number;
	is_deletable: boolean;
}
export function GradPlanAssociationsModel_ClassTransform_Type() {
	return GradPlanAssociationsModel;
}

export class GradPlanEditorModel {
	id: number;
	first_name: string;
	last_name: string;
}

export function GradPlanEditorModel_ClassTransform_Type() {
	return GradPlanEditorModel;
}

export class GradPlanOverviewModel {
	id: number;
	title: string;
	catalog_id: number;
	catalog_title: string;
	endorsement: string;
	default_program_group: string;
	default_program_group_title: string;
	@Transform(dateTransformer)
	creation_date: Date;
	@Transform(dateTransformer)
	last_edited_date: Date;
	@Type(GradPlanEditorModel_ClassTransform_Type)
	last_edited_by: GradPlanEditorModel;
	@Transform(dateTransformer)
	deactivation_date: Date;
	@Type(GradPlanAssociationsModel_ClassTransform_Type)
	associations: GradPlanAssociationsModel;
}

export function GradPlanOverviewModel_ClassTransform_Type() {
	return GradPlanOverviewModel;
}

export class GradPlansModel {
	@Type(GradPlanOverviewModel_ClassTransform_Type)
	results: GradPlanOverviewModel[];
	count: number;
}

export interface SearchGradPlansArgument {
	id: PagingSearchFieldArgument;
	title: PagingSearchFieldArgument;
	creation_date: PagingSearchFieldArgument;
	last_edited_date: PagingSearchFieldArgument;
	deactivation_date: PagingSearchFieldArgument;
	required_subject_area_credits: PagingSearchFieldArgument;
	program_count: PagingSearchFieldArgument;
	student_count: PagingSearchFieldArgument;
}
